module.exports = __webpack_public_path__ + "static/beaver-mountain-21d230ec53c410eeb1b4d869f43e9aee.jpg";